import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Jwtuser } from '../_models/jwtuser';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<Jwtuser>;
  public currentUser: Observable<Jwtuser>;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<Jwtuser>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): Jwtuser {
    return this.currentUserSubject.value;
  }

  login(credentials): Observable<any> {
    console.log("Login method called with username ", credentials.username);
    return this.http.post(`${environment.ptsl_api_url}/User/Login`, {
      username: credentials.username,
      password: credentials.password,
      accountnumber: credentials.accountnumber
    }, httpOptions)
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        console.log("User = ", user);
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
        return user;
      }))
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
  }
}